module.exports = __webpack_public_path__ + "static/media/doodle_liquidity.b1f52677.png";